import React from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Tooltip from '../../common/Tooltip';
import JoinLeftIcon from '@mui/icons-material/JoinLeft';
import GroupWorkOutlinedIcon from '@mui/icons-material/GroupWorkOutlined';
import { useCurrentBoardState } from '../../../services/state';

const WithChildrenSettings = () => {
  const boardState = useCurrentBoardState();
  const moveGroupsWithChildren = boardState.moveWithChildren.get();

  return (
    <ButtonGroup color="menuActive" sx={{ marginRight: '2rem' }}>
      <Tooltip title="Move and delete groups together with their child circles">
        <Button onClick={() => boardState.merge({ moveWithChildren: true })}>
          <GroupWorkOutlinedIcon color={moveGroupsWithChildren ? 'menuActive' : 'white'} />
        </Button>
      </Tooltip>
      <Tooltip title="Move and delete groups without their children">
        <Button onClick={() => boardState.merge({ moveWithChildren: false })}>
          <JoinLeftIcon color={moveGroupsWithChildren ? 'white' : 'menuActive'} />
        </Button>
      </Tooltip>
    </ButtonGroup>
  );
};

export default WithChildrenSettings;
